import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Page } from '@dhl-ui/page'
import { ChevronRightIcon } from '@dhl-ui/icons'

import { Box, H1, List, ListItem, ListItemText, Paper } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { locales } from '~/i18n'
import { BackButton } from '~/temp-ds-component/BackButton'

export const LanguagePage = () => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const navigate = useNavigate()

  useEffect(() => {
    document.documentElement.lang = language.split('-')[0]
  }, [language])

  // delete?
  const onBack = () => navigate(links.profileOverviewLink())

  const selectLanguage = async (language: string) => {
    await i18n.changeLanguage(language)
  }

  return (
    <Page>
      <H1>{t('admin.profile.languagePage.titleText')}</H1>

      <Box sx={{ mt: 27, gap: 2, height: '100vh' }}>
        <Paper>
          <List>
            {locales().map((locale) => (
              <ListItem
                key={`language-${locale}`}
                onClick={() => selectLanguage(locale)}
                slotProps={{ secondaryIcon: <ChevronRightIcon /> }}
                data-testid="language-item"
              >
                <ListItemText
                  primary={t(`languages.long.${locale}`)}
                  secondary={locale === language ? t(`languages.current`) : undefined}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <BackButton onClick={() => onBack()}>{t('admin.profile.languagePage.backButton')}</BackButton>
        </Box>
      </Box>
    </Page>
  )
}
